import React, { useState } from 'react'
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { BiSupport } from "react-icons/bi";
import { MdKeyboardArrowDown } from "react-icons/md";
import { IoIosCall } from "react-icons/io";
import { Link } from 'react-router-dom';

export default function Dropdown() {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    return (
        <div>
            <Button
                id="basic-button"
                aria-controls={open ? 'basic-menu' : undefined}
                aria-haspopup="true"
                className={open ? 'dropdown-open' : ''}
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
                startIcon={<BiSupport />}
                endIcon={<MdKeyboardArrowDown />}
            >
                Support
            </Button>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                className={open ? 'dropdown-open' : ''}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
            >
                {/* <MenuItem component={Link} to="/" onClick={handleClose}>Support home</MenuItem> */}
                <MenuItem component="a" href="tel:+38349456023" onClick={handleClose}>
                    <IoIosCall /> +38349456023
                </MenuItem>
            </Menu>
        </div>
    );
}